import React, { useMemo } from 'react';
import { Container } from 'components/UI';
import { Title } from '@landing/ui';
import { useWindowResize } from 'utils/hooks';
import GalleryImage from './GalleryImage';

import * as styles from './Gallery.module.scss';

export default function Gallery({ title, items }) {
  const { width } = useWindowResize();
  const isMobile = width <= 545;
  const sortedItems = useMemo(() => {
    const result = [...items];
    if (isMobile) {
      for (let i = 7; i < result.length; i += 8) {
        if (i - 2 >= 0) {
          const temp1 = result[i];
          const temp2 = result[i - 2];
          result[i] = result[i - 1];
          result[i - 1] = temp2;
          result[i - 2] = temp1;
        }
      }
      return result;
    }
    return items;
  }, [isMobile]);

  return (
    <Container>
      <div className={styles.layout}>
        <Title color="white">{title}</Title>
        <div className={styles.gallery}>
          <div className={styles.row}>
            {sortedItems.map((item, i) => (
              <GalleryImage key={i} index={i} item={item} items={sortedItems} />
            ))}
          </div>
        </div>
      </div>
    </Container>
  );
}
